import { render, staticRenderFns } from "./Last.vue?vue&type=template&id=3147bc1d&scoped=true&"
import script from "./Last.vue?vue&type=script&lang=js&"
export * from "./Last.vue?vue&type=script&lang=js&"
import style0 from "./Last.vue?vue&type=style&index=0&id=3147bc1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147bc1d",
  null
  
)

component.options.__file = "Last.vue"
export default component.exports